<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : !disabled ? '修改' : '查看'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
    class="missionPart"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="80px"
    >
      <div class="tablePart">
        <el-form-item label="供应商" prop="orgId">
          <el-select
            v-model="dataForm.orgId"
            :disabled="disabled"
            @change="getPeriodList()"
          >
            <el-option
              v-for="(item, index) in orgList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="公司" prop="companyId">
          <el-select
            v-model="dataForm.companyId"
            :disabled="disabled"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="时段" prop="periodWithTimeName" v-if="dataForm.id">
          <el-input
            v-model="dataForm.periodWithTimeName"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="时段" prop="periodId" v-if="!dataForm.id">
          <el-select
            v-model="dataForm.orgPeriodId"
            :disabled="disabled"
            filterable
            clearable
            multiple
            @change="getSpaceList"
          >
            <el-option
              v-for="(item, index) in periodList"
              :key="index"
              :label="item.periodWithTimeName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="星期" prop="weeks" class="fullList">
          <el-checkbox-group
            v-model="dataForm.weeks"
            size="medium"
            @change="getSpaceList()"
          >
            <el-checkbox-button
              v-for="(item, index) in weeksList"
              :key="index"
              :label="item.id"
              >{{ item.week }}</el-checkbox-button
            >
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="生效日期" prop="startDate">
          <el-date-picker
            v-model="dataForm.startDate"
            :disabled="disabled"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="终止日期" prop="endDate">
          <el-date-picker
            v-model="dataForm.endDate"
            :disabled="disabled"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </div>
      <div class="newTablePart">
        <div class="firstTable">
          <el-table :data="usedSpace" border stripe height="300px">
            <el-table-column
              prop="freezerName"
              header-align="center"
              align="center"
              label="冷柜名称"
            />
            <el-table-column
              prop="space"
              header-align="center"
              align="center"
              label="分配仓位"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.space"
                  :controls="false"
                  :min="0"
                  :precision="0"
                  class="inputNumberInside"
                  @change="changeCount($event, scope.row)"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="newTable">
          <div class="tablePart" v-if="!disabled">
            <el-button
              type="primary"
              @click="addSpace()"
              class="el-icon-add-location"
              v-if="!disabled"
              >添加</el-button
            >
          </div>
          <el-table
            :data="spaceList"
            border
            stripe
            ref="spaceList"
            @selection-change="selectionChange"
            height="300px"
          >
            <el-table-column
              type="selection"
              header-align="center"
              align="center"
              width="50"
            />
            <el-table-column
              prop="freezerName"
              header-align="center"
              align="center"
              label="冷柜名称"
            />
            <el-table-column
              prop="space"
              header-align="center"
              align="center"
              label="总仓位"
            />
            <el-table-column
              prop="usedSpace"
              header-align="center"
              align="center"
              label="已使用仓位"
            />
            <el-table-column
              prop="remainingSpace"
              header-align="center"
              align="center"
              label="剩余仓位"
            />
            <el-table-column
              header-align="center"
              align="center"
              label="分配仓位"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.cage"
                  :controls="false"
                  :min="0"
                  :precision="0"
                  class="inputNumberInside"
                  @change="countNum($event, scope.$index)"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()" v-if="!disabled"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      disabled: false,
      visible: false,
      dataForm: {
        id: '',
        orgId: '',
        companyId: '',
        orgPeriodId: [],
        startDate: '',
        endDate: '',
        weeks: [1, 2, 3, 4, 5, 6, 7],
        isUnified: 1,
        periodWithTimeName: '',
      },
      orgList: [],
      companyList: [],
      periodList: [],
      usedSpace: [],
      initialSpace: [],
      Space: [],
      spaceList: [],
      orgPeriodCompany: [],
      dataListSelections: [],
      weeksList: [
        { id: 1, week: '一' },
        { id: 2, week: '二' },
        { id: 3, week: '三' },
        { id: 4, week: '四' },
        { id: 5, week: '五' },
        { id: 6, week: '六' },
        { id: 7, week: '日' },
      ],
      dataRule: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.getOrgList();
    this.getCompanyList();
    this.getPeriodList();
  },
  methods: {
    init(id, disabled) {
      this.dataForm.orgPeriodId = [];
      this.disabled = disabled;
      this.dataForm.id = id || '';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields();
        this.usedSpace = [];
        this.initialSpace = [];
        this.Space = [];
        this.spaceList = [];
        if (this.dataForm.id) {
          this.$http({
            url: `/tc/orgperiodcompany/info/${this.dataForm.id}`,
            method: 'get',
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.dataForm = { ...data.orgperiodcompany };
              this.dataForm.weeks = data.orgperiodcompany.weeks
                ? data.orgperiodcompany.weeks
                    .split(',')
                    .map((item) => parseInt(item))
                : [];
              this.dataForm.orgPeriodId = [data.orgperiodcompany.orgPeriodId];
              this.usedSpace = data.orgperiodcompany.usedSpace;
              this.initialSpace = this.usedSpace.map((item) => {
                return { freezerId: item.freezerId, space: item.space };
              });
              this.spaceList = data.orgperiodcompany.spaceList;
            }
          });
        }
      });
    },
    getCompanyList() {
      this.$http({
        url: `/tc/company/combo`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.companyList = data.list;
        }
      });
    },
    getOrgList() {
      this.$http({
        url: `/cc/org/all`,
        method: 'get',
        params: { type: 0, isUse: 1 },
      }).then(({ data }) => {
        if (data && data.status === 0) {
          this.orgList = data.data.items;
        }
      });
    },
    //
    selectionChange(val) {
      this.dataListSelections = val;
    },
    countNum(data, theIndex) {
      this.spaceList.forEach((i, index) => {
        if (index === theIndex) {
          if (parseInt(i.remainingSpace - data) < 0) {
            i.cage = i.remainingSpace;
            this.$message.error(
              `最大可选择的仓位数量为${i.remainingSpace},已为您选择最大可选择仓位数`,
            );
          }
        }
      });
    },
    addSpace() {
      this.Space = this.dataListSelections
        .filter((item) => item.space > 0)
        .map((item) => {
          return {
            freezerId: item.freezerId,
            freezerName: item.freezerName,
            space: item.cage,
          };
        });
      for (let i = 0; i < this.Space.length; i++) {
        if (
          this.spaceList.filter(
            (item) => item.freezerId === this.Space[i].freezerId,
          ).length > 0
        ) {
          let space = this.spaceList.filter(
            (item) => item.freezerId === this.Space[i].freezerId,
          )[0];
          space.remainingSpace -= this.Space[i].space;
          space.usedSpace += this.Space[i].space;
          space.cage = 0;
        }
        if (
          this.usedSpace.filter(
            (item) => item.freezerId === this.Space[i].freezerId,
          ).length > 0
        ) {
          this.usedSpace.filter(
            (item) => item.freezerId === this.Space[i].freezerId,
          )[0].space += this.Space[i].space;
        } else {
          this.usedSpace.push({
            freezerId: this.Space[i].freezerId,
            freezerName: this.Space[i].freezerName,
            space: this.Space[i].space,
          });
        }
      }
      this.initialSpace = this.usedSpace.map((item) => {
        return { freezerId: item.freezerId, space: item.space };
      });

      this.$nextTick(() => {
        this.dataListSelections = [];
        this.$refs.spaceList.clearSelection();
      });
    },
    changeCount(data, row) {
      let space = this.initialSpace.filter(
        (item) => item.freezerId === row.freezerId,
      )[0];
      let diffSpace = space.space - row.space;
      let spaceList = this.spaceList.filter(
        (item) => item.freezerId === row.freezerId,
      )[0];
      spaceList.remainingSpace += diffSpace;
      spaceList.usedSpace -= diffSpace;
      space.space = row.space;
      if (row.space === 0) {
        this.usedSpace.splice(
          this.usedSpace.findIndex((item) => item.freezerId === row.freezerId),
          1,
        );
      }
    },
    getPeriodList() {
      if (this.dataForm.orgId) {
        this.$http({
          url: `/tc/orgperiod/combo/${this.dataForm.orgId}`,
          method: 'get',
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.periodList = data.list;
          }
        });
      }
    },
    getSpaceList() {
      if (
        this.dataForm.weeks.length > 0 &&
        this.dataForm.orgPeriodId.length > 0
      ) {
        const weeks = this.dataForm.weeks.join(',');
        const orgPeriodId = this.dataForm.orgPeriodId.join(',');
        this.$http({
          url: `/tc/orgperiodcompanyfreezer/spaceList/${weeks}/${orgPeriodId}`,
          method: 'get',
        }).then(({ data }) => {
          if (data && data.code === 0) {
            if (data.spaceList && data.spaceList?.length) {
              data.spaceList.forEach((i) => {
                i.cage = 0;
              });
            }
            this.spaceList = data.spaceList;
          }
        });
      } else {
        this.spaceList = [];
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `/tc/orgperiodcompany/${
              !this.dataForm.id ? 'save' : 'update'
            }`,
            method: 'post',
            data: {
              id: this.dataForm.id,
              isUnified: this.dataForm.isUnified,
              companyId: this.dataForm.companyId,
              startDate: this.dataForm.startDate,
              endDate: this.dataForm.endDate,
              weeks: this.dataForm.weeks.map((i) => i).join(','),
              orgPeriodIds: this.dataForm.orgPeriodId.map((i) => i).join(','),
              spaceList: this.usedSpace,
            },
          }).then(({ data }) => {
            if (data && data.status === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              });
              this.visible = false;
              this.$emit('success');
            } else if (data && data.status === 422) {
              this.$message({
                message: data.errors.periodId,
                type: 'error',
                duration: 1500,
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.inputNumberInside {
  width: 100%;
  .el-input__inner {
    border: none;
  }
}
.newTablePart {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  overflow: hidden;
  .newTable {
    width: 70%;
    position: relative;
  }
  .firstTable {
    width: 30%;
    position: relative;
  }
}
</style>
